import styled, { css } from 'styled-components';
import { Flex } from '@bookjane2/bookjane-design-library';
import { elementDimensions } from 'constants/elementDimensions';

const { DesktopPageHeaderHeight, MobilePageHeaderHeight, SetupBanner, NavigationWidth } =
  elementDimensions;

interface IReportsViewportFrame {
  x: number;
  isPendingApproval: boolean;
}

interface IReportsPageViewTemplate extends IReportsViewportFrame {
  flexDirection: 'row' | 'column';
}

export const reportsViewportFrameCss = css<IReportsViewportFrame>`
  ${({ x, theme, isPendingApproval }) => {
    return css`
      position: fixed;
      top: ${DesktopPageHeaderHeight + (isPendingApproval ? SetupBanner : 0)}px;
      right: 0;
      bottom: 0;

      @media (max-width: ${theme.breakpoints.Tablet}) {
        top: ${MobilePageHeaderHeight}px;
        left: ${x}px;
        right: unset;
        bottom: 0;
        width: calc(100% - ${x}px);
      }

      ${x ? `width: calc(100% - ${NavigationWidth}px - ${x}px);` : `width: auto;`}
    `;
  }}
`;

export const ReportsPageViewTemplate = styled(Flex)<IReportsPageViewTemplate>`
  ${reportsViewportFrameCss}
  overflow-y: auto;
  overflow-x: hidden;
  background-color: ${({ theme }) => theme.colors.White};
`;

export const AnalyticsHeaderTag = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 12px;
  color: ${({ theme }) => theme.colors.Grey6};
  white-space: nowrap;
`;

export const HeaderRightGroup = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const DataFreshnessLabel = styled.span`
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 12px;
  color: ${({ theme }) => theme.colors.Grey6};
  white-space: nowrap;
`;

export const ReportContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.White};
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.colors.Grey3};
`;
